module.exports = __webpack_public_path__ + "static/media/mohtawa.a4497f03.webp";